<div class="col-12 text-center mt-5">
  <h4>Subscribe to Our Mailing List</h4>
  <p>Thanks for your interest! Please provide the info below to register.</p>
</div>
<div class="col-12 mt-5 mb-5">
  <form [formGroup]="form" class="row row-cols-lg-auto g-3 justify-content-center">
    <div class="col-12 col-md-6">
      <label class="label">First Name*</label><br>
      <input formControlName="first_name" type="text" class="form-control"
        [ngClass]="hasError && f.first_name.errors?.required ? 'is-invalid' : ''">
    </div>
    <div class="col-12 col-md-6">
      <label class="label">Last Name*</label><br>
      <input formControlName="last_name" type="text" class="form-control"
        [ngClass]="hasError && f.last_name.errors?.required ? 'is-invalid' : ''">
    </div>
    <div class="col-12">
      <label class="label">Email Address*</label><br>
      <input formControlName="email" type="email" class="form-control"
        [ngClass]="hasError && f.email.errors?.required ? 'is-invalid' : ''">
    </div>
    <div class="col-12">
      <br>
      <button class="btn btn-outline-primary learn-btn sub-btn" (click)="submitForm()">Subscribe</button>
    </div>
  </form>
</div>
